import React from 'react';
import { Box } from '@qga/roo-ui/components';

import ToggleContent from '@shared/v2/components/ToggleContent';

import LinkButton from '@/components/LinkButton';
import TermsAndConditionModal from '@/components/TermsAndConditionModal';
import Text from '@/components/Text';
import { useRoomOptionsData } from '@/v2/components/pages/PackageViewV2/contexts/RoomOptionsContext';
import usePrependFlightInclusion from '@/v2/components/pages/PackageViewV2/hooks/usePrependFlightInclusion';
import PackageDetails from '@/v2/components/ui/PackageDetails';
import { UI } from '@/v2/types';
import { convertLeadInOfferInclusion } from '@/v2/utils/inclusions';

interface TermsAndConditionsProps {
  campaign?: UI.Campaign | null;
  propertyContent?: UI.Property;
  procuredOffer?: UI.ProcuredOffer | null;
}

const TermsAndConditions = ({
  campaign,
  propertyContent,
  procuredOffer,
}: TermsAndConditionsProps) => {
  const isProcuredOffer = !!procuredOffer;
  const { selectedPackageOption } = useRoomOptionsData() || {};
  const baseInclusions = (
    selectedPackageOption?.cheapestOffer?.leadInOffer?.inclusions ?? []
  ).map(convertLeadInOfferInclusion);
  const inclusions = usePrependFlightInclusion(baseInclusions);

  if (isProcuredOffer && !!propertyContent && !!selectedPackageOption) {
    return (
      <Box px={[4, null, 8]} pt={[3, null, 1]} pb={[3, null, 4]}>
        <PackageDetails
          propertyContent={propertyContent}
          procuredOffer={procuredOffer}
          leadInOffer={selectedPackageOption?.cheapestOffer?.leadInOffer}
          inclusions={inclusions ?? []}
        />
      </Box>
    );
  }

  if (campaign?.homePageHero?.termsConditions) {
    return (
      <Box px={[4, null, 8]} py="4">
        <ToggleContent
          toggle={(show) => (
            <LinkButton hover noPadding fontSize="sm" onClick={() => show()}>
              <Text>
                View{' '}
                {`${
                  campaign.sashing
                    ? `${campaign.sashing?.flightPillText} - `
                    : ''
                } sale terms `}
              </Text>
            </LinkButton>
          )}
          content={(closeModal) => (
            <TermsAndConditionModal
              close={closeModal as any}
              title={`${
                campaign.sashing ? `${campaign.sashing?.flightPillText} - ` : ''
              }Sale terms`}
              content={campaign.homePageHero?.termsConditions ?? ''}
            />
          )}
        />
      </Box>
    );
  }

  return <></>;
};

export default TermsAndConditions;
